export const accountWithMostRecommendation = [
    {
        "tenantName": "Demo Advertiser",
        "totalReco": 60,
        "details": [
            {
                "recoTypeName": "Keyword",
                "recoCount": 30
            },
            {
                "recoTypeName": "Geo",
                "recoCount": 30
            }
        ]
    },
]

